

import { Options, Vue } from "vue-class-component";
// import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'

@Options({
  components: {},
})
export default class AndroidDownload extends Vue {
  mounted() {
    // @ts-ignore
    let downloadUrl = this.$route.query['url'];
    if (downloadUrl) {
      location.href = downloadUrl as string
    }
  }
  
}
